export const styles = {
  helpful_count: {
    color: "#000000",
    position: "relative",
    left: -15,
    fontWeight: "bold",
  },
};
